import {
  Box,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import { DateBadge } from "./DateBadge";
import { TimeChip } from "./TimeChip";
import { TimesTableProps } from "./types";
import { getTimeKey, isSlotSelected } from "./utils";

const TABLE_BORDER_COLOR = APP_COLORS.greyLight6;

const TABLE_SX: SxProps<Theme> = {
  borderCollapse: "collapse",
  "& .MuiTableCell-root": {
    borderBottom: `1px solid ${TABLE_BORDER_COLOR}`,
  },
  "& .MuiTableBody-root .MuiTableRow:last-child .MuiTableCell-root": {
    borderBottom: "none",
  },
  "& .MuiTableHead-root .MuiTableCell-root:first-of-type, & .MuiTableBody-root .MuiTableCell-root:first-of-type":
    {
      borderRight: `1px solid ${TABLE_BORDER_COLOR}`,
    },
};

const TABLE_CONTAINER_SX: SxProps<Theme> = {
  borderRadius: 1.5,
  border: `1px solid ${TABLE_BORDER_COLOR}`,
  overflow: "hidden",
};

const TABLE_CELL_SX: SxProps<Theme> = {
  py: 1.25,
  px: 1.25,
};

const TABLE_HEADER_CELL_SX: SxProps<Theme> = {
  py: 1,
};

export function TimesTable({
  dateKeys,
  slotsByDate,
  selectedSlot,
  isTimeConfirmed,
  onSlotSelect,
}: TimesTableProps) {
  if (dateKeys.length === 0) return null;

  return (
    <TableContainer component={Box} sx={TABLE_CONTAINER_SX}>
      <Table size="small" sx={TABLE_SX}>
        <TableHead>
          <TableRow>
            <TableCell width={80} align="center" sx={TABLE_HEADER_CELL_SX}>
              <Typography variant="caption" fontWeight={600} color="text.secondary">
                Date
              </Typography>
            </TableCell>
            <TableCell sx={TABLE_HEADER_CELL_SX}>
              <Typography variant="caption" fontWeight={600} color="text.secondary">
                Times
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dateKeys.map((dateKey) => {
            const times = slotsByDate[dateKey] ?? [];

            return (
              <TableRow key={dateKey} sx={{ verticalAlign: "middle" }}>
                <TableCell align="center" sx={TABLE_CELL_SX}>
                  <DateBadge dateKey={dateKey} />
                </TableCell>
                <TableCell sx={TABLE_CELL_SX}>
                  <FlexBox flexWrap="wrap" gap={0.625}>
                    {times.map((slot) => (
                      <TimeChip
                        key={getTimeKey(slot)}
                        slot={slot}
                        selected={isSlotSelected(slot, selectedSlot, isTimeConfirmed)}
                        onClick={() => onSlotSelect(slot)}
                      />
                    ))}
                  </FlexBox>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
